import React, { useEffect } from 'react';
import { LoadingOverlay, Translate, Logo } from '../../Share/components';

import { showChat } from '../../Share/utils';

function LoginLayout(props) {
  useEffect(() => {
    showChat();
  }, []);
  return (
    <>
      <div className="tv-bg-login-page">
        <div className="d-flex w-100 px-4 mt-4">
          <Logo />
        </div>
        <div className="tv-login-page__form-container">{props.children}</div>
      </div>
      <LoadingOverlay />
    </>
  );
}

export default LoginLayout;
